import React, { ReactElement } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeSanitize from 'rehype-sanitize';
import Carousel from '../Carousel';
import s from './Portfolio.module.scss';
import { Project } from '../../shared/schema/ProjectSchema';
import { isAddressCoordinates } from '../../shared/stringUtils';
import { remarkDoubleBold } from '../../utils/remarkPlugins';

interface DescriptionProps {
  project: Project;
}

const Description = (props: DescriptionProps): ReactElement => {
  const { project } = props;

  return (
    <>
      {!isAddressCoordinates(project.address) && (
        <div className={s.subTitle}>{project.address}</div>
      )}
      {project.images.length > 0 && (
        <div className={s.carouselWrapper}>
          <Carousel
            images={project.images.filter((i) => i.visible).map((i) => i.path)}
          />
        </div>
      )}
      <ReactMarkdown
        className={s.description}
        rehypePlugins={[rehypeSanitize]}
        remarkPlugins={[remarkDoubleBold]}
      >
        {project.description}
      </ReactMarkdown>
    </>
  );
};

export default Description;
